export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9891.09ef4c76.jpg";